module.exports = "/images/clock.svg?d9b85b50ec68df5946eb102299533f91";